import keys from 'lodash.keys';
import defaults from 'lodash.defaults';
import remove from 'lodash.remove';
import uuid from 'node-uuid';
import options from './options';

class Utils {
  static defaults(...args) {
  	return defaults(...args);
  }
  static keys(obj) {
  	return keys(obj);
  }
  static remove(...args) {
  	return remove(...args);
  }
  static log(...messages) {
    if (options.debug) { return console.log(...messages); }
  }
  static uuid() {
  	return uuid.v4();
  }
}

export default Utils;



/** WEBPACK FOOTER **
 ** ./src/utils.js
 **/